import {
  ADMIN_STYLE_PROFILE_API_TYPE,
  SERVICE_TABS,
} from "../constant/constant";
import authHttp from "./authHttp";

export const createStyleProfile = async (val) => {
  const url = "api/create-new/style-profile";
  const res = await authHttp.post(url, val);
  return res;
};

export const editStyleProfile = async (val) => {
  const url = "api/update/style-profile";
  const res = await authHttp.post(url, val);
  return res;
};
export const editProjectStyleProfile = async (val) => {
  const url = "api/update/project-style-profile";
  const res = await authHttp.post(url, val);
  return res;
};

export const getStyleProfile = async (id) => {
  const url = `api/get-style-profile/style_profile_video/${id}`;
  const {
    data: { data },
  } = await authHttp.get(url);
  return data;
};
export const getStyleProfilePhoto = async (id) => {
  const url = `api/get-style-profile/style_profile_photo/${id}`;
  const {
    data: { data },
  } = await authHttp.get(url);
  return data;
};

export const getAdminSideStyleProfile = async ({ id, type }) => {
  if (!id || !type) {
    throw new Error("Missing required parameters: id or type");
  }
  const url = `api/get-style-profile/${type}/${id}`;
  const {
    data: { data },
  } = await authHttp.get(url);
  return data;
};

export const getProjectStyleProfile = async (id) => {
  const url = `api/get-style-profile/project/${id}`;
  const {
    data: { data },
  } = await authHttp.get(url);
  return data;
};

// deprecated
export const adminStyleProfile = async (val) => {
  const url = "api/admin-internal-notes";
  const res = await authHttp.post(url, val);
  return res;
};

export const updateStyleProfileV2 = async (val) => {
  const url = "/api/update/existing-style-profile";
  const res = await authHttp.post(url, val);
  return res;
};

// API to get presigned URL of every asset to upload.
export const getPresignedUrl = async (val) => {
  const url = "api/get-presigned-url";
  const res = await authHttp.post(url, val);
  return res;
};

// API to upload the asset to S3.
export const confirmUploadFile = async (val) => {
  const url = "api/confirm-upload";
  const res = await authHttp.post(url, val);
  return res;
};
